import React, { useState, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import AuthContext from "flexbiz-core/components/auth/Context";
import { motion } from 'framer-motion';

// Import các icon từ Material-UI
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HomeIcon from '@mui/icons-material/Home';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
//import AssessmentIcon from '@mui/icons-material/Assessment';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
//import Inventory2Icon from '@mui/icons-material/Inventory2';
//import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
//import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PersonIcon from '@mui/icons-material/Person';

// Component icon tùy chỉnh để hiển thị đúng kiểu selected/unselected
const NavIcon = ({ selectedIcon, unselectedIcon, isSelected }) => {
    return isSelected ? selectedIcon : unselectedIcon;
};
const NavButton = React.forwardRef(({ label, icon, isSelected, onClick }, ref) => (
    <ButtonBase
        ref={ref} // Gắn ref vào phần tử DOM
        onClick={onClick}
        sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            position: 'relative',
            zIndex: 2,
            color: isSelected ? 'primary.main' : 'text.secondary',
            transition: 'color 0.3s'
        }}
    >
        {icon}
        <Typography variant="caption" sx={{ mt: 0.5, fontWeight: isSelected ? 'bold' : 'normal' }}>
            {label}
        </Typography>
    </ButtonBase>
));
// Thêm displayName để debug dễ hơn
NavButton.displayName = 'NavButton';

function ButtonNavi({ defaultValue, history, code }) {
    if(defaultValue==undefined && code){
      if(code=="dmvt_agent") defaultValue = 1;
      if(code=="introducecode_agent") defaultValue = 2;
      if(code=="profile") defaultValue = 3;
    }


    const location = useLocation();
    const [value, setValue] = React.useState(defaultValue || 0);
    const context = React.useContext(AuthContext);

    const handleNavigation = (newValue) => {
        setValue(newValue);
        switch(newValue){
          case 0:
            setValue(newValue);
            history.replace('/')
            break;
          case 1:
            setValue(newValue);
            history.push('/list/dmvt_agent?use_navigate_default=1')
            break;
          case 2:
            setValue(newValue);
            history.push(`/ctv-network`)
            break;
          case 3:{
            setValue(newValue);
            history.push({
              pathname: `/profile`,
              search: '',state:{previousLocation: location}
            })
            break;
          }
        }
    };


     
    const navItems = [
        { label: context.apis.getLabel("Home"), selectedIcon: <HomeIcon />, unselectedIcon: <HomeOutlinedIcon /> },
        { label: context.apis.getLabel("Cửa hàng"), selectedIcon: <img src="/images/shop.png" style={{width:24,height:24}} />, unselectedIcon: <AssessmentOutlinedIcon /> },
        { label: context.apis.getLabel("Bạn bè"), selectedIcon: <img src="/images/introducer.png" style={{width:24,height:24}} />, unselectedIcon: <Inventory2OutlinedIcon /> },
        { label: context.apis.getLabel("Tài khoản"), selectedIcon: <PersonIcon />, unselectedIcon: <PersonOutlineOutlinedIcon /> },
    ];

    // --- PHẦN LOGIC MỚI ĐỂ ĐO LƯỜNG VỊ TRÍ ---
    const buttonsRef = useRef([]); // Mảng chứa ref của các nút
    const [pillStyle, setPillStyle] = useState({ left: 0, width: 60 }); // Style cho viên thuốc

    // useLayoutEffect sẽ chạy sau khi DOM đã được render nhưng trước khi trình duyệt vẽ ra màn hình
    // -> Giúp tránh hiện tượng giật/nháy hình
    useLayoutEffect(() => {
        const selectedButton = buttonsRef.current[value];
        if (selectedButton) {
            setPillStyle({
                left: selectedButton.offsetLeft, // Lấy vị trí bên trái của nút
                width: selectedButton.offsetWidth, // Lấy chiều rộng thực tế của nút
            });
        }
    }, [value, navItems.length]); // Chạy lại khi item được chọn thay đổi
    
    return (
        <Box sx={{
            position: 'fixed',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'calc(100% - 32px)',
            maxWidth: '500px', // Giới hạn chiều rộng trên thiết bị lớn
            pb: '16px', // Padding an toàn + khoảng hở
        }}>
            <Box sx={{
                position: 'relative',
                display: 'flex',
                height: '64px',
                borderRadius: '32px',
                padding: '0 8px', // Thêm padding để các nút con không bị sát viền
                overflow: 'visible', // Cho phép shadow hiển thị đẹp hơn
                backdropFilter: 'blur(20px)',
                backgroundColor: 'rgba(240, 240, 240, 0.75)',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            }}>
                {/* --- Viên thuốc chỉ báo với style được đo lường --- */}
                <motion.div
                    style={{
                        position: 'absolute',
                        top: '8px',
                        height: 'calc(100% - 16px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: '24px',
                        zIndex: 1,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    }}
                    animate={pillStyle} // Animate tới style đã được tính toán
                    transition={{ type: 'spring', stiffness: 350, damping: 30 }}
                />

                {navItems.map((item, index) => (
                    <NavButton
                        key={index}
                        // Gán ref tương ứng cho mỗi nút
                        ref={(el) => (buttonsRef.current[index] = el)}
                        label={item.label}
                        isSelected={value === index}
                        onClick={() => handleNavigation(index)}
                        icon={<NavIcon
                            isSelected={value === index}
                            selectedIcon={item.selectedIcon}
                            unselectedIcon={item.unselectedIcon}
                        />}
                    />
                ))}
            </Box>
        </Box>
    );
}

ButtonNavi.propTypes = {
    history: PropTypes.any,
    defaultValue: PropTypes.number,
    code: PropTypes.any
};

export default ButtonNavi;
